import { PfpScoProviderProfileComponent } from '../components/P4P/ProviderProfile';
import PfpRHProviderProfileComponent from '../components/P4P/ProviderProfile/PfpRHProviderProfileComponent';
import { Constants } from '../constants/appConstants';
import { useAppContext } from '../Context';
import ComponentHeader from './ComponentHeader';
import { useLocation } from 'react-router';

function PfpProviderProfile() {
  const location = useLocation();
  const {
    providerType: contextProviderType,
    reviewYear: contextReviewYear
  } = useAppContext();

  const providerType =
    location?.state?.providerType ?? contextProviderType;

  const reviewYear =
    location?.state?.reviewYear ?? contextReviewYear;

  const isSCOType = providerType === Constants.SCOKey;

  const items = [
    { label: 'Dashboard', path: '/pfp/providers' },
    { label: 'Provider Profile', path: '/pfp/providerProfile' }
  ];

  return (
    <>
      {isSCOType ?
        <div style={{ marginTop: '42px', marginBottom: '50px', marginLeft: '5px' }}>
          <ComponentHeader
            breadcrumbs={items}
            providerType={providerType}
            reviewYear={reviewYear}
            hideProviderTypeDropdown
          />
          <PfpScoProviderProfileComponent />
        </div>
        :
        <div style={{ marginTop: '42px', marginBottom: '50px', marginLeft: '5px' }}>
          <ComponentHeader
            breadcrumbs={items}
            providerType={providerType}
            reviewYear={reviewYear}
            hideProviderTypeDropdown
          />
          <PfpRHProviderProfileComponent />
        </div>
      }
    </>
  );
}

export default PfpProviderProfile;